/**
 * @generated SignedSource<<fef40a44093ab5a6898b43c1c9e8afdc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type sentiment_issueFieldSentimentReadviewFull_SentimentReadView$data = {
  readonly sentiment: {
    readonly name: string | null | undefined;
    readonly sentimentId: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "sentiment_issueFieldSentimentReadviewFull_SentimentReadView";
};
export type sentiment_issueFieldSentimentReadviewFull_SentimentReadView$key = {
  readonly " $data"?: sentiment_issueFieldSentimentReadviewFull_SentimentReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"sentiment_issueFieldSentimentReadviewFull_SentimentReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "sentiment_issueFieldSentimentReadviewFull_SentimentReadView",
  "selections": [
    {
      "concreteType": "JiraServiceManagementSentiment",
      "kind": "LinkedField",
      "name": "sentiment",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "sentimentId"
        },
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    }
  ],
  "type": "JiraServiceManagementSentimentField"
};

(node as any).hash = "8517cf83a9bc093cb7026b5204afe566";

export default node;
